<template>
    <div>
      <strong>{{ t('notifications.alerts.salesAssistance') }}</strong><br />
        <AlertText msg-key="notifications.alerts.pdd" :zone="zone" :time="time" />
    </div>
</template>

<script setup>
  import { i18n } from '@/i18n'
  import AlertText from './AlertText.vue'

  defineProps({
      zone: String,
      time: Number
  })
  // Shown inside a toast (vue-toastification's own app, no $t there) as well as in the bell.
  const t = (key) => i18n.global.t(key)
</script>
